export default "__VITE_ASSET__D_A91jTC__"